export default "__VITE_ASSET__BH9tAR1l__"